import React from 'react';
import { isEqual } from 'lodash';

import { mpartial } from '../../utils';

import Checkbox from '../form/Checkbox';
import Down from 'material-ui/svg-icons/navigation/expand-more';
import Up from 'material-ui/svg-icons/navigation/expand-less';

import { ColumnType } from './constants';
import { Order } from './dataProvider';

const style = {
  sortIcon: {
    width: 14,
  },
};

export default class Header extends React.Component {
  static cellClass = column => {
    switch (column.type) {
      case ColumnType.ENUM:
      case ColumnType.TEXT:
        return 'text';
      case ColumnType.NUMBER:
        return 'number';
      case ColumnType.CHECK:
        return 'check';
      case ColumnType.YESNO:
        return 'yesno';
      case ColumnType.DATETIMEWITHOUTZONE:
      case ColumnType.DATETIME:
        return 'datetime';
      case ColumnType.DATE:
        return 'date';
      case ColumnType.TIME:
        return 'time';
      case ColumnType.JSX:
        return 'jsx';
      default:
        return '';
    }
  };

  static cellStyle = ({ width }) => ({
    width,
  });

  static reverseOrder = order => order === Order.DESC ? Order.ASC : Order.DESC;

  static sortIconLeft = () => false;

  handleColumnHeaderClick = (column, sorted) => {
    const { order, onOrderChange, onSortChange } = this.props;
    if (column.sortable) {
      if (sorted) {
        onOrderChange(Header.reverseOrder(order));
      } else {
        onSortChange(column.sortBy ? column.sortBy : column.field);
      }
    }
  };

  handleAllCheck = value => {
    const { onSelectedChange, items } = this.props;

    if (value.length !== items.length) {
      onSelectedChange(items.map(item => item.id));
    } else {
      onSelectedChange([]);
    }
  };

  renderColumnHeaderIcon = sorted => {
    const { order } = this.props;
    if (sorted) return order === Order.ASC ? <Up style={style.sortIcon} /> : <Down style={style.sortIcon} />;

    return <Down style={style.sortIcon} />;
  };

  renderHeaderCheckbox = () => {
    const { items, selected, allowCheckAll } = this.props;
    const ids = items.map(item => item.id);

    if (!allowCheckAll) {
      return <th className="selector" />;
    }

    return (
      <th className="selector">
        <Checkbox value={isEqual(ids, selected)} onChange={mpartial(this.handleAllCheck, selected)} aria-label="Vybrat vše" />
      </th>
    );
  };

  renderColumnHeader = column => {
    const { sort } = this.props;
    const sorted = (column.sortBy ? column.sortBy : column.field) === sort;

    const onKeyDown = (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.handleColumnHeaderClick(column, sorted);
      }
    };

    return (
      <span role="button" tabIndex={0} className={sorted ? 'sorted' : ''} 
        onClick={mpartial(this.handleColumnHeaderClick, column, sorted)}
        onKeyDown={onKeyDown}>
        {column.sortable && (Header.sortIconLeft(column) && this.renderColumnHeaderIcon(sorted))}
        {column.label}
        {column.sortable && (!Header.sortIconLeft(column) && this.renderColumnHeaderIcon(sorted))}
      </span>
    );
  };

  render() {
    const { columns, editing, deleting, allowCheck } = this.props;
    const displayActionCheckbox = editing || deleting || allowCheck ? true : false;

    return (
      <thead>
        <tr>
          {displayActionCheckbox && this.renderHeaderCheckbox()}
          {columns.filter(c => c.display !== false).map((column, i) => (
            <th key={i} className={Header.cellClass(column)} style={Header.cellStyle(column)} scope="col">
              {this.renderColumnHeader(column)}
            </th>
          ))}
        </tr>
      </thead>
    );
  }
}
